import { render } from "./finalTransportation.vue?vue&type=template&id=f1d4fab0&ts=true"
import script from "./finalTransportation.vue?vue&type=script&lang=ts"
export * from "./finalTransportation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__